var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"tab-list"},_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:index,staticClass:"tab",class:{
          'tab-active': tab.active,
          'forceWordSpacing': _vm.forceWordSpacing
      },style:({ fontSize: _vm.tabFontSize, width: _vm.tabWidth }),on:{"click":function($event){return _vm.selectTab(tab)}}},[_vm._v("\n        "+_vm._s(tab.tabTitle)+"\n      ")])}),0),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }